module.exports = __webpack_public_path__ + "static/seres-silk-duvet-1-ow-47d65ff6bc01f3af2ad4e129f10701b1.png";